import React, { useState } from 'react';
import referenceImg from '../../assets/screening-tna-tne-reference.jpg';

// TNA / TNE Assessment 的判斷準則（Word 表 Section B）——判 TNE／TNA 要對照
// Q1–Q5 與整體評估規則，那張表不在系統裡，填的人只能另外去翻。
// 預設收合成一行連結，接在 screening 六題的最後一題底下，也接在 QC6/QC7 表單
// Particulars 表格正下方（緊接「Basis for the TNA assessment」，QcForm 依題目的 reference 標記放）；
// 表單已經很長，圖不搶戲。只在填答面顯示。
const ScreeningTnaReference = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="mt-2">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="text-xs text-blue-600 hover:text-blue-800 underline"
      >
        {open ? 'Hide Reference' : 'View Reference'}
      </button>
      {open && (
        <div className="mt-2 border border-slate-200 rounded-lg p-3 bg-slate-50">
          <p className="text-xs font-medium text-slate-500 mb-2">
            Reference — the TNA / TNE assessment criteria:
          </p>
          <img
            src={referenceImg}
            alt="TNA / TNE assessment criteria, questions Q1 to Q5 and the overall evaluation rules"
            className="max-w-full rounded border border-slate-200"
          />
        </div>
      )}
    </div>
  );
};

export default ScreeningTnaReference;
